<div>
  <header class="container-fluid clearfix">
    <span class="subheader">INDEX ARCHIVING</span>
    <h1>Linear Playout</h1>
  </header>
  <main>
    <div class="wrapper-header">
      <mat-card class="wrapper-container center">
        <div class="col-sm">
          <div class="row center">
            <div class="wrapper-station">
              <mat-form-field appearance="outline">
                <mat-label>Station</mat-label>

                <input
                  data-testid="station"
                  type="text"
                  matInput
                  [formControl]="stationGroupCtrl"
                  name="station"
                  required
                  [matAutocomplete]="autoGroup"
                  style="max-width: 140px"
                />
                <app-badge-station
                  *ngIf="(stationGroupCtrl?.value && stationGroupCtrl.value?.stationSources)"
                  [mergedStation]="stationGroupCtrl.value"
                ></app-badge-station>
                <button
                  type="button"
                  mat-button
                  *ngIf="stationGroupCtrl.value"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearStation()"
                >
                  <mat-icon class="clear-button">close</mat-icon>
                </button>

                <mat-autocomplete
                  #autoGroup="matAutocomplete"
                  [displayWith]="displayStation"
                  (optionSelected)="selectStation($event.option.value)"
                  [autoActiveFirstOption]="true"
                >
                  <mat-optgroup
                    *ngFor="let marketGroup of marketGroupOptions | async"
                    [label]="marketGroup.name"
                  >
                    <mat-option
                      *ngFor="let mergedStation of marketGroup.mergedStations"
                      [value]="mergedStation"
                    >
                      {{ mergedStation.name }}
                      <app-badge-station
                        [mergedStation]="mergedStation"
                      ></app-badge-station>
                    </mat-option>
                  </mat-optgroup>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field class="station-timezone" appearance="outline">
                <mat-label>Station timezone</mat-label>
                <input
                  data-testid="station-timezone"
                  matInput
                  disabled
                  [value]="stationTimeZone"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-sm">
          <div class="source">
            <app-single-dropbox
            class="single-dropbox"
            [isDisabled]="isStationSourcesDropboxDisable"
            [allowMultiple]="false"
            cssClassToApply="dropbox-145 single-dropbox-custom"
            popupPositionLeft="44"
            [(ngModel)]="stationSourceSelected"
            placeholder="Select Source"
            placeholderLabel="Find a source..."
            noEntriesFoundLabel="No source found"
            (selectionChanged)="selectStationSource($event)"
            #stationSourceMulti
          >
          </app-single-dropbox>
          </div>
        </div>
        <div class="col-sm">
          <div class="row center">
            <div class="wrapper-picker">
              <mat-label [matTooltip]="daysTooltip()">Date<mat-icon class="icon-display">info</mat-icon></mat-label>
              <ng2-flatpickr
                #startPicker
                data-input-type="date"
                [config]="startOptions"
                [formControl]="dateCtrl"
                name="date"
              >
              </ng2-flatpickr>
              <mat-icon matSuffix class="date-p-icon">event</mat-icon>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
    <div class="wrapper-header">
      <div class="wrapper-table">
        <div class="days">
          <mat-tab-group
            [selectedIndex]="getSelectedIndex()"
            (selectedTabChange)="onTabChange($event)"
          >
            <mat-tab
              class="day-tab"
              *ngFor="let tab of tabs; let tabIndex = index"
            >
              <ng-template mat-tab-label>{{ tab.title }} </ng-template>
            </mat-tab>
          </mat-tab-group>
          <div class="tab-content">
            <div class="table-container">
              <app-linear-playout-table
                [dataList]="tableDataList.asObservable()"
                (callbackDownload)="callbackDownload($event)"
                [finishDownload]="finishDownload.asObservable()"
                [listDownload]="listDownload.asObservable()"
                [loading]="loading"
                [selectLines]="regionsOfDates.asObservable()"
                (selectedLines)="selectedLines($event)"
                [disableAllDownloadButton]="
                  disableAllDownloadButton.asObservable()
                "
              ></app-linear-playout-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper-header">
      <div class="wrapper-table">
        <div class="days">
          <mat-card>
            <app-sia-loading [show]="!audioReady"></app-sia-loading>
            <app-sia-wavesurfer 
              [hidden]="streamUrl == null"
              [dataChanges]="streamUrl" 
              [hour]="selectedTab.currentTabIndex"
              [regionIn]="regionsSubject.asObservable()"
              [clearRegion]="clearRegion.asObservable()"
              (audioReady)="audioReadyToListening($event)"
              (clearRegions)="onClearSelection()"
              (regionOut)="regionChanged($event)" 
              (nextHour)="onNextHour($event)"
              (previousHour)="onPreviousHour($event)"
              >
            </app-sia-wavesurfer>
            <div class="no-url" *ngIf="streamUrl == null && audioReady">
              {{messageNoAudioAvailable}}
              <ng-content></ng-content>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
    <div class="wrapper-header row">
      <div class="col-sm">
        <button
          data-testid="download-button"
          [class.primary-button-disabled]="isDownloadButtonDisabled"
          [class.primary-button]="!isDownloadButtonDisabled"
          [disabled]="isDownloadButtonDisabled"
          mat-button
          (click)="waveSelectionDownload()"
          class="float-right no-outline margin-bottom"
        >
          DOWNLOAD
        </button>
      </div>
    </div>
  </main>
</div>
